import hash from 'object-hash'

/***
 * sha1 hex encoding (default)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hashFile(file: any) {
  return hash(file)
}
